import React, { Fragment, useContext } from 'react';
import MapSegment from '@components/overlap/map-segment';
import OverlapContext from '@components/overlap/overlap-context';
import DotmapsLoader from '@shared/dotmaps-loader';

const MapComponents = () => {
  const { segments } = useContext(OverlapContext);

  if (segments) {
    return (
      <Fragment>
        {segments.filter(segment => segment?.shape).map(segment => (
          <MapSegment key={segment.id} segment={segment} />
        ))}
      </Fragment>
    );
  }

  return <DotmapsLoader key="loader" />;
};

export default MapComponents;
